(() => {
  const root = document.querySelector('[data-hematite-aura]');
  if (!root) return;

  const q = (selector, scope = root) => scope.querySelector(selector);
  const qa = (selector, scope = root) => [...scope.querySelectorAll(selector)];
  const variantsScript = q('[data-ha-variants]');
  let variants = [];
  try { variants = JSON.parse(variantsScript?.textContent || '[]'); } catch (error) { variants = []; }

  const currency = root.dataset.currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR';
  const formatMoney = (cents) => {
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency }).format(Number(cents || 0) / 100); }
    catch (error) { return `${(Number(cents || 0) / 100).toFixed(2)} ${currency}`; }
  };

  const slides = qa('[data-ha-slide]');
  const thumbs = qa('[data-ha-thumb]');
  let activeSlide = 0;
  const showSlide = (index) => {
    if (!slides.length) return;
    activeSlide = (index + slides.length) % slides.length;
    slides.forEach((slide, slideIndex) => {
      const active = slideIndex === activeSlide;
      slide.classList.toggle('is-active', active);
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', String(!active));
      slide.querySelectorAll('video').forEach((video) => { if (!active) video.pause(); });
    });
    thumbs.forEach((thumb, thumbIndex) => {
      const active = thumbIndex === activeSlide;
      thumb.classList.toggle('is-active', active);
      thumb.setAttribute('aria-selected', String(active));
      if (active) thumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    });
  };
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => showSlide(index)));
  q('[data-ha-gallery-prev]')?.addEventListener('click', () => showSlide(activeSlide - 1));
  q('[data-ha-gallery-next]')?.addEventListener('click', () => showSlide(activeSlide + 1));

  let touchStartX = 0;
  const galleryStage = q('.ha-gallery__stage');
  galleryStage?.addEventListener('touchstart', (event) => { touchStartX = event.changedTouches[0].clientX; }, { passive: true });
  galleryStage?.addEventListener('touchend', (event) => {
    const delta = event.changedTouches[0].clientX - touchStartX;
    if (Math.abs(delta) > 45) showSlide(activeSlide + (delta < 0 ? 1 : -1));
  }, { passive: true });

  const form = q('.ha-product-form');
  const variantInput = q('[data-ha-variant-id]');
  const priceEls = qa('[data-ha-price], [data-ha-sticky-price]');
  const compareEl = q('[data-ha-compare]');
  const discountEl = q('[data-ha-discount]');
  const stockEl = q('[data-ha-stock]');
  const addButtons = qa('[data-add-to-cart]');
  const selectedOptions = () => qa('[data-ha-option]').map((group) => q('.ha-option__button.is-selected', group)?.dataset.haOptionValue || '');
  const selectedVariant = () => {
    const options = selectedOptions();
    return variants.find((variant) => (variant.options || []).every((value, index) => value === options[index])) || variants[0];
  };

  const updateVariant = () => {
    const variant = selectedVariant();
    if (!variant) return;
    if (variantInput) variantInput.value = variant.id;
    priceEls.forEach((element) => { element.textContent = formatMoney(variant.price); });

    if (compareEl) {
      const hasCompare = Number(variant.compare_at_price || 0) > Number(variant.price || 0);
      compareEl.hidden = !hasCompare;
      compareEl.textContent = hasCompare ? formatMoney(variant.compare_at_price) : '';
      if (discountEl) {
        discountEl.hidden = !hasCompare;
        discountEl.textContent = hasCompare ? `${Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)}%` : '';
      }
    }

    addButtons.forEach((button) => {
      button.disabled = !variant.available;
      const label = q('[data-add-text]', button);
      if (label) label.textContent = variant.available ? (button.dataset.addLabel || 'ADD TO BAG') : (button.dataset.soldOutLabel || 'SOLD OUT');
    });

    if (stockEl) {
      const stockMessage = variant.available ? (stockEl.dataset.stockIn || 'In stock') : (stockEl.dataset.stockOut || 'This option is currently unavailable');
      stockEl.classList.toggle('is-out', !variant.available);
      stockEl.replaceChildren(document.createElement('span'), document.createTextNode(` ${stockMessage}`));
    }

    if (variant.featured_media && variant.featured_media.id) {
      const mediaIndex = slides.findIndex((slide) => String(slide.dataset.haSlide) === String(variant.featured_media.id));
      if (mediaIndex >= 0) showSlide(mediaIndex);
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());
  };

  qa('.ha-option__button').forEach((button) => {
    button.addEventListener('click', () => {
      const group = button.closest('[data-ha-option]');
      qa('.ha-option__button', group).forEach((item) => {
        const active = item === button;
        item.classList.toggle('is-selected', active);
        item.setAttribute('aria-pressed', String(active));
      });
      updateVariant();
    });
  });

  const quantityInput = q('[data-ha-quantity-input]');
  const quantityLabel = q('[data-ha-qty]');
  let quantity = Number(quantityInput?.value || 1);
  const updateQuantity = (next) => {
    quantity = Math.max(1, Math.min(10, next));
    if (quantityInput) quantityInput.value = String(quantity);
    if (quantityLabel) quantityLabel.textContent = String(quantity);
  };
  q('[data-ha-qty-minus]')?.addEventListener('click', () => updateQuantity(quantity - 1));
  q('[data-ha-qty-plus]')?.addEventListener('click', () => updateQuantity(quantity + 1));

  const buyBox = q('.ha-buybox');
  qa('[data-ha-scroll-buy]').forEach((button) => button.addEventListener('click', () => {
    buyBox?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => q('.ha-option__button.is-selected')?.focus({ preventScroll: true }), 550);
  }));

  qa('[data-ha-scroll-next]').forEach((button) => button.addEventListener('click', () => {
    const targetId = button.dataset.target;
    const target = targetId ? document.getElementById(targetId) : null;
    target?.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }));

  qa('[data-ha-quiz]').forEach((quiz) => {
    const steps = qa('[data-ha-quiz-step]', quiz);
    const result = q('[data-ha-quiz-result]', quiz);
    const progressBar = q('[data-ha-quiz-progress]', quiz);

    steps.forEach((step, index) => {
      qa('[data-ha-quiz-answer]', step).forEach((answer) => answer.addEventListener('click', () => {
        qa('[data-ha-quiz-answer]', step).forEach((option) => option.classList.toggle('is-selected', option === answer));
        window.setTimeout(() => {
          step.hidden = true;
          step.classList.remove('is-active');
          const nextStep = steps[index + 1];
          if (nextStep) {
            nextStep.hidden = false;
            nextStep.classList.add('is-active');
            if (progressBar) progressBar.style.width = `${((index + 2) / steps.length) * 100}%`;
            q('[data-ha-quiz-answer]', nextStep)?.focus({ preventScroll: true });
          } else if (result) {
            result.hidden = false;
            if (progressBar) progressBar.style.width = '100%';
            result.setAttribute('tabindex', '-1');
            result.focus({ preventScroll: true });
          }
        }, 220);
      }));
    });
  });

  const revealObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12 }) : null;
  qa('[data-ha-reveal]').forEach((element) => revealObserver ? revealObserver.observe(element) : element.classList.add('is-visible'));

  const counterObserver = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      const element = entry.target;
      const target = Number(element.dataset.haCounter || 0);
      const start = performance.now();
      const duration = 900;
      const tick = (now) => {
        const progress = Math.min(1, (now - start) / duration);
        element.textContent = String(Math.round(target * (1 - Math.pow(1 - progress, 3))));
        if (progress < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      counterObserver.unobserve(element);
    });
  }, { threshold: 0.8 }) : null;
  qa('[data-ha-counter]').forEach((element) => counterObserver ? counterObserver.observe(element) : element.textContent = element.dataset.haCounter);

  const visuals = q('[data-ha-visuals] .ha-visuals__track');
  const scrollVisuals = (direction) => visuals?.scrollBy({ left: visuals.clientWidth * 0.78 * direction, behavior: 'smooth' });
  q('[data-ha-visual-prev]')?.addEventListener('click', () => scrollVisuals(-1));
  q('[data-ha-visual-next]')?.addEventListener('click', () => scrollVisuals(1));

  const sticky = q('[data-ha-sticky]');
  const hero = q('.ha-ad-hero') || q('.ha-hero');
  const footer = q('.ha-footer');
  const updateSticky = () => {
    if (!sticky || !hero) return;
    const heroBottom = hero.getBoundingClientRect().bottom;
    const footerTop = footer ? footer.getBoundingClientRect().top : Infinity;
    sticky.classList.toggle('is-visible', heroBottom < 80 && footerTop > window.innerHeight + 40);
  };

  const progress = q('[data-ha-progress]');
  const updateProgress = () => {
    if (!progress) return;
    const max = document.documentElement.scrollHeight - window.innerHeight;
    progress.style.width = `${max > 0 ? Math.min(100, Math.max(0, window.scrollY / max * 100)) : 0}%`;
  };

  let scrollQueued = false;
  window.addEventListener('scroll', () => {
    if (scrollQueued) return;
    scrollQueued = true;
    requestAnimationFrame(() => {
      updateSticky();
      updateProgress();
      scrollQueued = false;
    });
  }, { passive: true });

  form?.addEventListener('submit', () => {
    addButtons.forEach((button) => button.classList.add('is-loading'));
    window.setTimeout(() => addButtons.forEach((button) => button.classList.remove('is-loading')), 1800);
  });

  updateVariant();
  updateSticky();
  updateProgress();


  document.querySelectorAll('[data-ha-review-toggle]').forEach((button) => {
    const targetId = button.getAttribute('data-target');
    const target = targetId ? document.getElementById(targetId) : null;
    const label = button.querySelector('[data-ha-review-toggle-text]');
    if (!target) return;

    button.addEventListener('click', () => {
      const willOpen = target.hidden;
      target.hidden = !willOpen;
      button.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
      if (label) label.textContent = willOpen ? (button.dataset.expandedLabel || 'Show fewer reviews') : (button.dataset.collapsedLabel || 'Show reviews');
    });
  });
})();
